// @ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import ReactMapGL, { Source, Layer } from "react-map-gl";
import {
	clusterLayer,
	clusterCountLayer,
	unclusteredPointLayer,
	selectedPointLayer,
} from "./Layers";
import pin from "assets/pin.png";
import selected_pin from "assets/selected_pin.png";
import { db, IUserSite } from "../../database";
import "mapbox-gl/dist/mapbox-gl.css";
import { getEnvs } from "../../env";

type MapProps = {
	pinData?: any;
	mapPins?: object;
	position?: {
		latitude: number;
		longitude: number;
	};
	zoom: number;
	onSiteSelected: (site: IUserSite) => void;
	siteSelected: any;
};

type MarkerProps = {
	pinData?: any;
};

const Markers: React.FC<MarkerProps> = ({ pinData }) => {
	return (
		<>
			{" "}
			{pinData ? (
				<Source
					type="geojson"
					data={pinData}
					cluster={true}
					clusterMaxZoom={12}
					clusterRadius={50}
				>
					<Layer {...clusterLayer} />
					<Layer {...clusterCountLayer} />
					<Layer {...unclusteredPointLayer} />
					<Layer {...selectedPointLayer} />
				</Source>
			) : null}
		</>
	);
};

const Map: React.FC<MapProps> = (props: MapProps) => {
	const mapOptions = {
		initViewport: {
			latitude: 54.78487,
			longitude: -8.28094,
			zoom: props.zoom,
		},
	};

	const [MAP_BOX_API, setMAP_BOX_API] = useState("");

	useEffect(() => {
		async function setServerUrl() {
			try {
				const envvars: any = await getEnvs();
				setMAP_BOX_API(envvars.REACT_APP_MAP_BOX_API);
			} catch {
				setMAP_BOX_API("");
			}
		}

		setServerUrl();
	}, []);

	const NRMap = useRef();
	const [viewport, setViewport] = useState(mapOptions.initViewport);
	useEffect(() => {
		if (props.position && props.siteSelected) {
			setViewport({
				zoom: props.zoom,
				longitude: props.position.longitude,
				latitude: props.position.latitude,
			});
		} else {
			setViewport({
				...viewport,
				longitude: props.position?.longitude,
				latitude: props.position.latitude,
				zoom: props.zoom,
			});
		}
	}, [props.position]);
	useEffect(() => {
		if (props.zoom) {
			setViewport({ ...viewport, zoom: props.zoom });
		}
	}, [props.zoom]);

	const onMapClick = async (e: any) => {
		const feature = e.features.find(
			(f: any) =>
				f.layer.id === "unclustered-point" || f.layer.id === "selected-point"
		);
		if (feature) {
			const siteId = feature.properties.id;
			const getSelectedSite = await db.userSites
				.where("userSiteId")
				.equals(siteId);
			const selectedSite = await getSelectedSite.toArray();
			props.onSiteSelected(selectedSite[0]);
		}
	};

	const [imageLoaded, setImageLoaded] = useState();

	return (
		<>
			{MAP_BOX_API && (
				<ReactMapGL
					onLoad={() => {
						if (!NRMap.current) return;
						//@ts-ignore
						const map = NRMap.current.getMap();
						const isIE =
							!!window.MSInputMethodContext && !!document.documentMode;
						if (isIE) {
							const iePin = new Image();
							iePin.src = pin;
							iePin.onload = () => {
								setImageLoaded(true);
								map.addImage("pin", iePin);
							};
							const ieSelectedPin = new Image();
							ieSelectedPin.src = selected_pin;
							ieSelectedPin.onload = () => {
								map.addImage("selected_pin", ieSelectedPin);
							};
						} else {
							map.loadImage(pin, (error: Error, image: any) => {
								if (error) {
									console.log(error);
									return;
								}
								map.addImage("pin", image);
								setImageLoaded(true);
								map.loadImage(selected_pin, (error: Error, image: any) => {
									if (error) {
										console.log(error);
										return;
									}
									map.addImage("selected_pin", image);
									setImageLoaded(true);
								});
							});
						}
					}}
					onClick={onMapClick}
					mapboxApiAccessToken={MAP_BOX_API}
					{...viewport}
					mapStyle="mapbox://styles/mapbox/streets-v11"
					width="100vw"
					height="100vh"
					onViewportChange={(view) => {
						setViewport({ ...view });
					}}
					//@ts-ignore
					ref={NRMap}
				>
					{imageLoaded && <Markers pinData={props.pinData} />}
				</ReactMapGL>
			)}
		</>
	);
};

export default Map;
